module.exports = __webpack_public_path__ + "231392f27b9889ffdb812cdb10b30686.svg";